module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/our_services_1-f4d345b5b9e76cc3810a0d5194180fc9.jpg";